// extracted by mini-css-extract-plugin
export default {"swatch":"Swatch_swatch__3FXFf","active":"Swatch_active__MlCv+","colors":"Swatch_colors__24D2o","color":"Swatch_color__XQKvn","info":"Swatch_info__3yYR-"};